// src/reusableComponents/batches/MetricsCard.jsx
import React from "react";
import { Card, CardContent, Typography, Stack } from "@mui/material";
import PropTypes from "prop-types";
import {formatDurationValue} from "../../utlis/generalUtils";

const MetricsCard = ({ metrics }) => {
    return (
        <Card sx={{ borderRadius: 4, p: 2, mb: 4, boxShadow: "8px 8px 20px #d1d9e6, -8px -8px 20px #ffffff" }}>
            <CardContent>
                <Stack direction={{ xs: "column", sm: "row" }} spacing={4} justifyContent="space-between">
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Typography variant="subtitle2" color="text.secondary">Estimated Time per Page:</Typography>
                        <Typography variant="h6">{formatDurationValue(metrics.estimated_time_per_page) || 0}</Typography>
                    </Stack>

                    <Stack direction="row" spacing={1} alignItems="center">
                        <Typography variant="subtitle2" color="text.secondary">Total Digitized Files:</Typography>
                        <Typography variant="h6">{metrics.total_digitized_files || 0}</Typography>
                    </Stack>

                    <Stack direction="row" spacing={1} alignItems="center">
                        <Typography variant="subtitle2" color="text.secondary">Total Digitized Pages:</Typography>
                        <Typography variant="h6">{metrics.total_digitized_pages || 0}</Typography>
                    </Stack>

                    <Stack direction="row" spacing={1} alignItems="center">
                        <Typography variant="subtitle2" color="text.secondary">Total Digitization Duration:</Typography>
                        <Typography variant="h6">{formatDurationValue(metrics.total_digitization_duration) || 0}</Typography>
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    );
};

MetricsCard.propTypes = {
    metrics: PropTypes.shape({
        estimated_time_per_page: PropTypes.number,
        total_digitized_files: PropTypes.number,
        total_digitized_pages: PropTypes.number,
        total_digitization_duration: PropTypes.number,
    }),
};

export default MetricsCard;
